(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-base"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__tpInit)return; window.__tpInit=1;
  function tpBoot(){

  
  var root = document;
  

  /* ===== BUNDLE ===== */
  var TP_TIERS = window.TP_TIERS || [];
  var TP_PACK_IMG = window.TP_PACK_IMG || "";
  var TP_SUB_SUFFIX = window.TP_SUBSCRIBE_SUFFIX || " · Subscribe & Save";
  var tpMode = window.TP_DEFAULT_MODE || "onetime";
  var tpSelected = Math.min(Math.max(window.TP_DEFAULT_TIER || 0, 0), Math.max(TP_TIERS.length - 1, 0));

  var tpPacksEl   = root.querySelector("#tpPacks");
  var tpCtaEl     = root.querySelector("#tpBundleCta");
  var tpCtaMain   = root.querySelector("#tpCtaMain");
  var tpCtaSub    = root.querySelector("#tpCtaSub");
  var tpSubNote   = root.querySelector("#tpSubNote");
  var tpTabsEl    = root.querySelector("#tpTabs");
  var tpStickyPrice = root.querySelector("#tpStickyPrice");
  var tpStickyLabel = root.querySelector("#tpStickyLabel");
  var tpTopbarPrice = root.querySelector("#tpTopbarPrice");
  var tpTopbarLabel = root.querySelector("#tpTopbarLabel");

  function tpSync(){
    if (!TP_TIERS.length) return;
    var t = TP_TIERS[tpSelected]; var d = t[tpMode];
    if (tpCtaEl) tpCtaEl.href = tpMode === "subscribe" ? t.url_subscribe : t.url_onetime;
    if (tpCtaMain) tpCtaMain.textContent = "Buy Now — " + d.price;
    if (tpCtaSub) tpCtaSub.textContent = t.name + " · " + t.supply;
    if (tpStickyPrice) tpStickyPrice.textContent = d.price;
    if (tpStickyLabel) tpStickyLabel.textContent = t.name;
    if (tpTopbarPrice) tpTopbarPrice.textContent = d.price;
    if (tpTopbarLabel) tpTopbarLabel.textContent = t.name + " · " + t.supply;
  }
  function tpRenderPacks(animatePrices){
    if (!tpPacksEl) return;
    tpPacksEl.innerHTML = "";
    TP_TIERS.forEach(function(t, i){
      var d = t[tpMode];
      var el = document.createElement("div");
      el.className = "tp-bundle__pack" + (i === tpSelected ? " is-selected" : "");
      el.setAttribute("role","radio");
      el.setAttribute("aria-checked", i === tpSelected ? "true" : "false");
      el.tabIndex = 0;
      el.innerHTML =
        (t.badge ? '<span class="tp-bundle__pack-badge">' + t.badge + '</span>' : '') +
        '<span class="tp-bundle__pack-radio"></span>' +
        '<span class="tp-bundle__pack-img">' +
          '<img src="' + (t.img || (window.TP_PACK_IMGS && window.TP_PACK_IMGS[i]) || TP_PACK_IMG) + '" alt="' + t.name + '" loading="lazy">' +
          '<span class="tp-bundle__pack-qty">' + t.qty + '</span>' +
        '</span>' +
        '<span class="tp-bundle__pack-info">' +
          '<span class="tp-bundle__pack-name">' + t.name + '</span>' +
          '<span class="tp-bundle__pack-supply">' + t.supply + '</span><br>' +
          '<span class="tp-bundle__pack-savings' + (animatePrices ? " tp-price-swap" : "") + '">' + d.save + '</span>' +
        '</span>' +
        '<span class="tp-bundle__pack-prices">' +
          '<span class="tp-bundle__pack-price' + (animatePrices ? " tp-price-swap" : "") + '">' + d.price + '</span>' +
          '<div class="tp-bundle__pack-unit">' + d.unit + '</div>' +
          '<div class="tp-bundle__pack-compare">' + t.compare + '</div>' +
        '</span>';
      var pick = function(){ tpSelected = i; var packs = tpPacksEl.querySelectorAll(".tp-bundle__pack"); for (var k=0;k<packs.length;k++){ var sel = (k===i); packs[k].classList.toggle("is-selected", sel); packs[k].setAttribute("aria-checked", sel?"true":"false"); } tpSync(); };
      el.addEventListener("click", pick);
      el.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(); } });
      tpPacksEl.appendChild(el);
    });
    tpSync();
  }
  root.querySelectorAll(".tp-bundle__tab").forEach(function(tab){
    tab.addEventListener("click", function(){
      if (tab.dataset.mode === tpMode) return;
      root.querySelectorAll(".tp-bundle__tab").forEach(function(b){ b.classList.remove("is-active"); b.setAttribute("aria-selected","false"); });
      tab.classList.add("is-active"); tab.setAttribute("aria-selected","true");
      tpMode = tab.dataset.mode;
      if (tpTabsEl) tpTabsEl.classList.toggle("is-subscribe", tpMode === "subscribe");
      if (tpSubNote) tpSubNote.classList.toggle("is-visible", tpMode === "subscribe");
      tpRenderPacks(true);
    });
  });
  (function(){
    var at = root.querySelector('.tp-bundle__tab[data-mode="' + tpMode + '"]');
    if (at) {
      root.querySelectorAll('.tp-bundle__tab').forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-selected','false'); });
      at.classList.add('is-active'); at.setAttribute('aria-selected','true');
    } else { tpMode = 'onetime'; }
    if (tpTabsEl) tpTabsEl.classList.toggle('is-subscribe', tpMode === 'subscribe');
    if (tpSubNote) tpSubNote.classList.toggle('is-visible', tpMode === 'subscribe');
  })();
  if (TP_TIERS.length) tpRenderPacks(false);

  /* ===== Accordions ===== */
  var tpAccItems = [].slice.call(root.querySelectorAll(".tp-acc__item"));
  tpAccItems.forEach(function(item){
    var btn = item.querySelector(".tp-acc__q");
    var panel = item.querySelector(".tp-acc__a");
    btn.addEventListener("click", function(){
      var wasOpen = item.classList.contains("is-open");
      tpAccItems.forEach(function(o){ o.classList.remove("is-open"); o.querySelector(".tp-acc__a").style.maxHeight = "0"; });
      if (!wasOpen) { item.classList.add("is-open"); panel.style.maxHeight = panel.scrollHeight + "px"; }
    });
  });

  /* ===== Marquees (clone) ===== */
  [["tpReviewsA",1],["tpReviewsB",1],["tpRibbonTrack",5],["tpBadgesTrack",3]].forEach(function(pair){
    var track = root.querySelector("#" + pair[0]);
    if (!track) return;
    var original = track.innerHTML;
    for (var i = 0; i < pair[1]; i++) track.innerHTML += original;
  });

  /* ===== Reveal + count-up + barras ===== */
  function tpCountUp(el){
    var target = parseFloat(el.dataset.count);
    var decimals = parseInt(el.dataset.decimals || "0", 10);
    var sep = el.dataset.sep || "";
    var dur = 1200, t0 = performance.now();
    function frame(now){
      var p = Math.min((now - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = (target * eased).toFixed(decimals);
      if (sep && !decimals) val = String(Math.round(target * eased)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      el.textContent = val;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  var tpObs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      e.target.classList.add("is-in");
      e.target.querySelectorAll(".tp-count").forEach(tpCountUp);
      if (e.target.classList.contains("tp-count")) tpCountUp(e.target);
      tpObs.unobserve(e.target);
    });
  }, { threshold: 0.18 });
  root.querySelectorAll(".tp-reveal,.tp-ingredient,#tpDailyList,.tp-reviews__scorebox").forEach(function(el){ tpObs.observe(el); });

  /* ===== Spotlight ===== */
  root.querySelectorAll(".tp-spot").forEach(function(card){
    card.addEventListener("pointermove", function(e){
      var r = card.getBoundingClientRect();
      card.style.setProperty("--mx", (e.clientX - r.left) + "px");
      card.style.setProperty("--my", (e.clientY - r.top) + "px");
    });
  });

  /* ===== Progress + parallax + sticky + back to top ===== */
  var tpProgress = root.querySelector("#tpProgress");
  var tpSticky = root.querySelector("#tpStickyCta");
  var tpTopbar = root.querySelector("#tpTopbar");
  var tpTopBtn = root.querySelector("#tpTop");
  var tpBundleSection = root.querySelector("#tp-bundle");
  var tpBenefits = root.querySelector(".tp-benefits") || root.querySelector(".tp-reviews");
  var tpParallax = [].slice.call(root.querySelectorAll("[data-parallax]"));
  var tpBundleInView = false;
  if (tpBundleSection) {
    new IntersectionObserver(function(es){ es.forEach(function(e){ tpBundleInView = e.isIntersecting; tpOnScroll(); }); }, { threshold: 0.12 }).observe(tpBundleSection);
  }
  var tpTicking = false;
  function tpOnScroll(){
    if (tpTicking) return;
    tpTicking = true;
    requestAnimationFrame(function(){
      var y = window.scrollY;
      var max = document.documentElement.scrollHeight - innerHeight;
      if (tpProgress) tpProgress.style.width = (y / max * 100) + "%";
      var passed = tpBenefits ? y > (tpBenefits.offsetTop - 200) : y > 400;
      if (tpSticky) tpSticky.classList.toggle("is-visible", passed && !tpBundleInView);
      if (tpTopbar) tpTopbar.classList.toggle("is-visible", passed && !tpBundleInView);
      if (tpTopBtn) tpTopBtn.classList.toggle("is-visible", y > 800);
      tpParallax.forEach(function(el){
        var r = el.getBoundingClientRect();
        el.style.transform = "translateY(" + ((r.top - innerHeight/2) * -0.08) + "px)";
      });
      tpTicking = false;
    });
  }
  window.addEventListener("scroll", tpOnScroll, { passive: true });
  tpOnScroll();
  if (tpTopBtn) tpTopBtn.addEventListener("click", function(){ window.scrollTo({ top: 0, behavior: "smooth" }); });

  /* ===== Dots do carrossel de results (mobile) ===== */
  var tpResGrid = root.querySelector("#tpResultsGrid");
  var tpDots = [].slice.call(root.querySelectorAll("#tpResultsDots i"));
  if (tpResGrid && tpDots.length) {
    tpResGrid.addEventListener("scroll", function(){
      var cards = [].slice.call(tpResGrid.children);
      var center = tpResGrid.scrollLeft + tpResGrid.clientWidth / 2;
      var idx = 0, best = Infinity;
      cards.forEach(function(c, i){ var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - center); if (d < best) { best = d; idx = i; } });
      tpDots.forEach(function(d, i){ d.classList.toggle("is-active", i === idx); });
    }, { passive: true });
  }

  }
  if(document.readyState!=='loading'){tpBoot();}else{document.addEventListener('DOMContentLoaded',tpBoot);}
})();


  } catch(e) { console.error(e); }
})();
})();
